import { Module } from 'vuex-smart-module';
import WidgetsActions from './actions';
import WidgetsGetters from './getters';
import WidgetsMutations from './mutations';
import WidgetsState from './state';

export default new Module({
  state: WidgetsState,
  mutations: WidgetsMutations,
  actions: WidgetsActions,
  getters: WidgetsGetters,
});
